import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../../../../constants/proptypes/AddonDiscoveryPropTypes";
import TextSearchWrapper from "../TextSearchWrapper";
import SmallTextSearchInner from "./SmallTextSearchInner";

var SmallTextSearch = /*#__PURE__*/function (_Component) {
  _inherits(SmallTextSearch, _Component);

  var _super = _createSuper(SmallTextSearch);

  function SmallTextSearch() {
    _classCallCheck(this, SmallTextSearch);

    return _super.apply(this, arguments);
  }

  _createClass(SmallTextSearch, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(TextSearchWrapper, {
        compact: true,
        extraProps: {
          onBlur: this.props.onBlur,
          onFocus: this.props.onFocus,
          screenClass: this.props.screenClass
        },
        filters: this.props.filters,
        onChange: this.props.onChange,
        perspective: this.props.perspective,
        searchComponent: SmallTextSearchInner,
        stateChangeRequested: this.props.stateChangeRequested
      });
    }
  }]);

  return SmallTextSearch;
}(Component);

_defineProperty(SmallTextSearch, "propTypes", {
  filters: CommonPropTypes.filters.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  screenClass: CommonPropTypes.screenClass.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
});

export { SmallTextSearch as default };